export const INITIAL_STATE = {
	hud: {
		turn_signal: 'NONE',
		speed: 10,
		speed_limit: 60,
		steering_angle: 45,
		traffic_light: 'UNKNOWN',
		mode: 'MANUAL',
		license: '',
		accel: 0,
		brake: 0,
		mode_indicator: 'UNKNOWN',
	},
	mode: {
		ready: true,
		pause: false,
		run: false,
	},
	map: {
		geojson: {
			type: 'FeatureCollection',
			features: [],
		},
		osmFile: '',
	},
	location: {
		lat: 0,
		lon: 0,
		hgt: 0,
		hdg: 0,
	},
	display: {
		mode: true,
		router: false,
		info: false,
		logger: false,
		updator: true,
	},
	goal: {
		dst_list: [],
		dst_mode: 0,
		selected_goal: '',
	},
	system: {
		status: '⛔',
		status_text: '',
		server_status: false,
	},
	sound: {
		sound_list: [],
		method: '',
		end_event: {},
	},
	logger: {
		status: null,
		upload: null,
		upload_progress: 0,
		on: false,
	},
	welcome: {
		text: null,
		greeting: false,
		introduction: false,
	},
	remote: {
		request: 0,
		approval: 0,
	},
	version: {
		checked: false,
		latest: false,
		accepted: false,
		minimum_version: '0.3.0',
		latest_version: '0.3.12',
		current_version: '0.0.0',
	},
	mission: {
		mission: 0,
		subMission: null,
	},
	autonomousKart: {
		parkingAvailable: false,
		cruiseTargetSpeed: 0,
	},
};
